import { render } from "./ScenariosSection.vue?vue&type=template&id=edc6c2fe&scoped=true"
import script from "./ScenariosSection.vue?vue&type=script&lang=js"
export * from "./ScenariosSection.vue?vue&type=script&lang=js"

import "./ScenariosSection.vue?vue&type=style&index=0&id=edc6c2fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc6c2fe"]])

export default __exports__